export default async function logoutUser() {
  try {
    localStorage?.clear();
    sessionStorage?.clear();
    if ("indexedDB" in window && indexedDB?.databases) {
      const databases = await indexedDB.databases();
      if (databases?.length) {
        await Promise.all(
          databases.map(
            (db) =>
              new Promise((resolve, reject) => {
                const deleteReq = indexedDB.deleteDatabase(db?.name);
                deleteReq.onsuccess = () => resolve();
                deleteReq.onerror = () => reject(deleteReq.error);
                deleteReq.onblocked = () => resolve();
              }),
          ),
        );
      }
    }
  } catch (err) {
    console.error("Logout Error:", err);
  } finally {
    localStorage?.clear();
    sessionStorage?.clear();
    window.location.replace("/");
  }
}
